"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "palette": {
        "primary": {
            "main": "#ffd100",
            "contrastText": "#000000"
        },
        "secondary": {
            "main": "#ffd100",
            "contrastText": "#000000"
        },
        "background": {
            "default": "#ffffff"
        },
        "text": {
            "primary": "#000000"
        }
    },
    "typography": {
        "fontFamily": "Open Sans",
        "button": {
            "fontWeight": 700,
            "fontSize": "1rem",
            "textTransform": "none"
        }
    },
    "googleFonts": [
        "Open Sans:300,300italic,regular,italic,600,600italic,700,700italic,800,800italic"
    ]
};
